import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '350px'
    }
  },
  list: {
    width: '100%',
    maxWidth: '350px',
    maxHeight: '200px',
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto'
  },
  inline: {
    width: '100%'
  },
  actionButton: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'end'
  },
  cancelButton: {
    color: theme.palette.gray_400.main,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.blue_300.main
    }
  },
  saveButton: {
    cursor: 'pointer',
    color: theme.palette.white_100.main,
    backgroundColor: theme.palette.blue_300.main,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.blue_400.main,
      boxShadow: 'none'
    }
  },
  textarea: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_50.main,
    borderRadius: '8px',
    '& textarea': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  }
}))
